<h2>
  {{ title }}
  <span *ngIf="model.Id" title="CHI Plan Id">- {{ model.Id }}</span>
  <span *ngIf="model.Name">- {{ model.Name }}</span>
</h2>
<hr />

<div class="divrel">
  <form (ngSubmit)="onSubmit()" #editPlanForm="ngForm" class="editForm" novalidate [ngBusy]="busy">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Name</label>
          <input type="text" #name class="form-control" name="Name" [(ngModel)]="model.Name" />
          <app-tooltip [form]="'system.plan'" [uid]="'Name'"></app-tooltip>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Payer</label>
          <app-select
            #payerList
            [items]="payerOptions"
            [allowClear]="false"
            [selected]="selectPayer"
            [removed]="selectPayer"
            placeholder="Select a Payer"
          >
          </app-select>
          <app-tooltip [form]="'system.plan'" [uid]="'Payer'"></app-tooltip>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Line Of Business</label>
          <app-select
            #linesOfBusinessList
            [items]="lineOfBusinessOptions"
            [allowClear]="false"
            [selected]="selectLineOfBusiness"
            [removed]="selectLineOfBusiness"
            placeholder="Select a Line of Business"
          >
          </app-select>
          <app-tooltip [form]="'system.plan'" [uid]="'LineOfBusiness'"></app-tooltip>
        </div>
      </div>
    </div>

    <div class="panel panel-default" *ngIf="model">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-8">
            <h3 class="panel-title">Accounting Data</h3>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Accounting Payer Id</label>
              <input
                type="number"
                class="form-control"
                name="AccountingPayerId"
                [(ngModel)]="model.AccountingPayerId"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Accounting Payer Name</label>
              <input
                type="text"
                class="form-control"
                name="AccountingPayerName"
                [(ngModel)]="model.AccountingPayerName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Invoice Term</label>
              <input
                type="number"
                class="form-control"
                name="PayerInvoiceTerm"
                [(ngModel)]="model.PayerInvoiceTerm"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Class Name</label>
              <input
                type="text"
                class="form-control"
                name="ClassName"
                [(ngModel)]="model.ClassName"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />
    <div class="row">
      <button class="btn btn-default pull-right" type="button" (click)="backToList()">
        Back to list
      </button>
      <button type="submit" class="btn btn-success pull-right" style="margin-right: 15px">
        Save
      </button>
    </div>
  </form>
</div>
